import seller from './seller';
import buyer from './buyer';
import admin from './admin';

export default {
  seller,
  buyer,
  admin,
};
